import type { UserProfile } from '@/shared/utils/format-status.js';

const ALL_PROFILES: UserProfile[] = ['ADM', 'PMO', 'CF', 'GPA', 'GPC', 'LT', 'DEV', 'UC'];

export function resolveAvailableProfiles(isAdm: boolean): UserProfile[] {
    return isAdm ? ALL_PROFILES : ALL_PROFILES.filter((p) => p !== 'ADM');
}
